import { ComponentType } from 'react'

import { UserResponseRole } from '@shared/models'

import {
  CompanyDetails,
  FormCompany,
  Home,
  Login as LoginPage,
  Mentions,
  NotFoundPage,
  ReportSettings,
  Reports,
  ServerError,
  Staff,
  Uploads,
  Welcome,
} from '@/pages'
import { Cena } from '@/pages/Cena/Cena.component'
import { SendResetPasswordCode } from '@/pages/Login/SendResetPasswordCode.component'
import { ResetPassword } from '@/pages/Login/ResetPassword.component'
import DashboardComponent from '@/pages/Dashboard/Dashboard.component'

export interface Route {
  component: ComponentType
  path: string

  key: string
  acceptVariable?: boolean
  isPrivate: boolean
  requiredRoles?: UserResponseRole[]
  showMenu?: boolean
}

export type RouteParams = {
  companyID: string
  channelID: string
}

export const Routes = {
  Welcome: {
    isPrivate: false,
    key: 'welcome',
    path: '/boas-vindas',
    component: Welcome,
  } as Route,
  Login: {
    isPrivate: false,
    key: 'login',
    path: '/login',
    component: LoginPage,
  } as Route,
  SendResetPasswordCode: {
    isPrivate: false,
    key: 'send-reset-password-code',
    path: '/enviar-codigo',
    component: SendResetPasswordCode,
  } as Route,
  ResetPassword: {
    isPrivate: false,
    key: 'reset-password',
    path: '/troca-de-senha',
    component: ResetPassword,
  } as Route,
  ServerError: {
    isPrivate: false,
    key: 'server-error',
    path: '/erro-servidor',
    component: ServerError,
  } as Route,
  NotFound: {
    isPrivate: false,
    key: 'not-found',
    path: '*',
    component: NotFoundPage,
  } as Route,

  Home: {
    isPrivate: true,
    key: 'home',
    path: '/',
    component: Home,
  } as Route,

  Mentions: {
    isPrivate: true,
    key: 'mentions',
    path: '/empresas/:companyID/mencoes',
    component: Mentions,
    showMenu: true,
  } as Route,
  Dashboard: {
    isPrivate: true,
    key: 'dashboards',
    path: '/dashboards',
    component: DashboardComponent,
  } as Route,
  Reports: {
    isPrivate: true,
    key: 'reports',
    path: '/empresas/:companyID/relatorios',
    component: Reports,
    showMenu: true,
  } as Route,
  Uploads: {
    isPrivate: true,
    key: 'company-details',
    path: '/empresas/:companyID/uploads',
    component: Uploads,
    showMenu: true,
  } as Route,
  Companies: {
    isPrivate: true,
    key: 'companies',
    path: '/empresas',
    component: FormCompany,
  } as Route,
  UpdateCompany: {
    isPrivate: true,
    key: 'update-company',
    path: '/empresas/:companyID/editar',
    component: FormCompany,
  } as Route,
  CompanyDetails: {
    isPrivate: true,
    key: 'company-details',
    path: '/empresas/:companyID',
    component: CompanyDetails,
    acceptVariable: true,
    showMenu: true,
  } as Route,
  ReportSettings: {
    isPrivate: true,
    key: 'customize-report',
    path: '/empresas/:companyID/personalizar-relatorio',
    component: ReportSettings,
    acceptVariable: true,
    showMenu: true,
  } as Route,
  Users: {
    isPrivate: true,
    showMenu: true,
    key: 'user',
    path: '/usuarios',
    component: Staff,
    requiredRoles: [UserResponseRole.AdminMaster],
  } as Route,
  Cena: {
    isPrivate: true,
    key: 'cena',
    path: '/cena',
    component: Cena,
  } as Route,
}
